import { defineMessages } from 'react-intl';

const scope = 'app.widgets.BusinessChange';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Change in Business',
    },
    titleDashboard: {
        id: `${scope}.titleDashboard`,
        defaultMessage: 'Change in Business -1 day',
    },
    sliderTitle: {
        id: `${scope}.slider.title`,
        defaultMessage: 'Showing change in the previous',
    },
    sliderMarkLabel: {
        id: `${scope}.slider.markLabel`,
        description: 'Label shown on slider',
        defaultMessage: `{range} {range, plural, one {day} other {days}}`,
    },
});

export const chartMessages = defineMessages({
    // Y AXIS
    yAxisLabel: {
        id: `${scope}.Graph.yAxis.label`,
        defaultMessage: 'Number of Rooms',
    },
    // BARS
    guaranteedGainLabel: {
        id: `${scope}.bars.gain.guaranteed.name`,
        description: 'Label for the guaranteed bar',
        defaultMessage: 'Guaranteed',
    },
    nonGuaranteedGainLabel: {
        id: `${scope}.bars.gain.nonGuaranteed.name`,
        description: 'Label for the nonGuaranteed bar',
        defaultMessage: 'Unguaranteed',
    },
    lossLabel: {
        id: `${scope}.bars.loss.name`,
        description: 'Label for the guaranteed loss bar',
        defaultMessage: 'Loss',
    },
    // TOOLTIP
    tooltipLabel: {
        id: `${scope}.Graph.tooltip.content.change.label`,
        description:
            'Label for any type of value shown in the tooltip with colon separation. Label is one the "bars" labels',
        defaultMessage: '{label}: {value}',
    },
    tooltipBreakdown_NEW_BOOKING: {
        id: `${scope}.Graph.tooltip.content.change.label.breakdown.NEW_BOOKING`,
        defaultMessage: 'New bookings: {value}',
    },
    tooltipBreakdown_DATE_CHANGE: {
        id: `${scope}.Graph.tooltip.content.change.label.breakdown.DATE_CHANGE`,
        defaultMessage: 'Date Changes: {value}',
    },
    tooltipBreakdown_CANCELLED: {
        id: `${scope}.Graph.tooltip.content.change.label.breakdown.CANCELLED`,
        defaultMessage: 'Cancellations: {value}',
    },
    tooltipBreakdown_ROOM_CHANGE: {
        id: `${scope}.Graph.tooltip.content.change.label.breakdown.ROOM_CHANGE`,
        defaultMessage: 'Room changes: {value}',
    },
});

export const filtersMessages = defineMessages({
    roomsLabel: {
        id: `${scope}.filters.rooms`,
        defaultMessage: 'Rooms',
    },
    revenueLabel: {
        id: `${scope}.filters.revenue`,
        defaultMessage: 'Revenue',
    },
});

export const csvExportLabels = defineMessages({
    exportLink: {
        id: `${scope}.csvExport.link`,
        defaultMessage: 'Export to CSV',
    },
    exportedFileName: {
        id: `${scope}.csvExport.filenamed`,
        defaultMessage: 'business-change',
    },
    // Column headers
    monthColumn: {
        id: `${scope}.csvExport.column.month`,
        defaultMessage: 'Month',
    },
    guaranteedRoomsGainColumn: {
        id: `${scope}.csvExport.column.gain.guaranteed.rooms`,
        defaultMessage: 'Guaranteed rooms gain',
    },
    nonGuaranteedRoomsGainColumn: {
        id: `${scope}.csvExport.column.gain.nonGuaranteed.rooms`,
        defaultMessage: 'Unguaranteed rooms gain',
    },
    roomsLossColumn: {
        id: `${scope}.csvExport.column.loss.rooms`,
        defaultMessage: 'Rooms loss',
    },
    guaranteedRevenueGainColumn: {
        id: `${scope}.csvExport.column.gain.guaranteed.revenue`,
        defaultMessage: 'Guaranteed revenue gain',
    },
    nonGuaranteedRevenueGainColumn: {
        id: `${scope}.csvExport.column.gain.nonGuaranteed.revenue`,
        defaultMessage: 'Unguaranteed revenue gain',
    },
    revenueLossColumn: {
        id: `${scope}.csvExport.column.loss.revenue`,
        defaultMessage: 'Revenue loss',
    },
    bookingsNewBookingColumn: {
        id: `${scope}.csvExport.column.bookings.NewBooking`,
        defaultMessage: '{type} New Booking',
    },
    bookingsDateChangeColumn: {
        id: `${scope}.csvExport.column.bookings.DateChange`,
        defaultMessage: '{type} Date Change',
    },
    bookingsRoomChangeColumn: {
        id: `${scope}.csvExport.column.bookings.RoomChange`,
        defaultMessage: '{type} Room Change',
    },
    bookingsCancelledColumn: {
        id: `${scope}.csvExport.column.bookings.Cancelled`,
        defaultMessage: '{type} Cancelled',
    },
});
